// extracted by mini-css-extract-plugin
export var completionBody = "_la-2";
export var completionCard = "_la-0";
export var completionFooter = "_la-3";
export var completionTitle = "_la-1";